<template>
    <div>
        <label :for="name" class="block text-sm font-medium text-gray-700">
            {{ label }}
        </label>
        <div class="mt-1">
            <input
                @input="$emit('update:modelValue', $event.target.value)"

                :id="name"
                :name="name"
                :type="type"
                :autocomplete="autocomplete"

                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        </div>
    </div>
    <small class="text-sm text-red-500" v-if="validation?.$error">{{ validation.$errors[0].$message }}</small>
</template>

<script>
export default {
    emits: ['update:modelValue'],
    props: {
        modelValue: { required: false },
        label: { required: true },
        name: { required: false },
        type: { default: 'text' },
        autocomplete: { default: 'off' },
        validation: { type: Object, required: false },
    },
};
</script>
